<template>
  <b-container fluid>
    <search fields="Verwerter,Betrieb,Von,Bis" @filterdata="filterMengen"></search>
    <table-responsive
      responsive
      ref="tableResponsiveMengen"
      :items="mengen"
      :field-definition="fields"
    ></table-responsive>
    <b-row class="mt-3">
      <b-col cols="6">{{ anzahl }} {{ $t('Meldungen') }}</b-col>
      <b-col cols="6" class="text-right">{{ $t('Total') }} {{ total }}</b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12" class="text-right">
        <b-link :href="excelURL">{{ $t('Download') }}</b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TableResponsive from "../components/tableResponsive.vue";
import moment from "moment";
import { apiURL, i18n } from "../main";

export default {
  name: "mengen",
  data() {
    return {
      fields: [
        {
          key: "datum",
          label: this.$t("Datum"),
          sortable: true,
          formatter: value => {
            return this.convertDate(value);
          }
        },
        {
          key: "verwerter",
          label: this.$t("Verwerter"),
          sortable: true,
          formatter: (value, key, item) => {
            return value + " - " + item.mbhID;
          }
        },
        {
          key: "agisID",
          label: this.$t("Betrieb"),
          sortable: true,
          formatter: (value, key, item) => {
            return item.betriebsform + " - " + value;
          }
        },
        {
          key: "tierart",
          label: this.$t("Tierart"),
          sortable: true
        },
        {
          key: "menge",
          label: this.$t("MengeKG"),
          sortable: true,
          class: "text-right",
          formatter: value => {
            return parseFloat(value).toLocaleString("de-CH", {
              minimumFractionDigits: 1
            });
          }
        }
      ]
    };
  },
  computed: {
    mengen() {
      return this.$store.state.mengenStore.mengen;
    },
    anzahl() {
      return this.$store.state.mengenStore.mengen.length;
    },
    total() {
      return parseFloat(
        this.$store.state.mengenStore.mengenTotal
      ).toLocaleString("de-CH", { minimumFractionDigits: 1 });
    },
    excelURL() {
      return (
        apiURL +
        "mengen.cfc?method=getMengenXls" +
        "&verwerter=" +
        this.$store.state.mengenStore.verwerterSelected +
        "&betrieb=" +
        this.$store.state.searchStore.searchValues.betriebSelected +
        "&von=" +
        moment(this.$store.state.searchStore.searchValues.von).format(
          "YYYYMM"
        ) +
        "&bis=" +
        moment(this.$store.state.searchStore.searchValues.bis).format(
          "YYYYMM"
        ) +
        "&language=" +
        i18n.locale
      );
    }
  },
  methods: {
    convertDate(value) {
      return moment(value)
        .locale(i18n.locale)
        .format("MMM YYYY");
    },
    filterMengen() {
      this.$store.dispatch("loadMengen");
    },
    loadExcel() {
      document.location.href = "/components/pis/mengen.cfc?method=getMengenXls";
    }
  },
  components: {
    "table-responsive": TableResponsive
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.$store.dispatch("loadMengen");
      self.$store.dispatch("loadVerwerter");
      window.addEventListener(
        "resize",
        self.$refs["tableResponsiveMengen"].responsiveRefresh
      );
    });
  },
  mounted() {},
  updated() {}
};
</script>